import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import useAuthStore from './store/authStore';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Estimations from './pages/Estimations';
import EstimationDetail from './pages/EstimationDetail';
import NewEstimation from './pages/NewEstimation';
import UsersAdmin from './pages/admin/Users';
import CatalogAdmin from './pages/admin/Catalog';
import BAQuestionsAdmin from './pages/admin/BAQuestions';
import Settings from './pages/Settings';
import './App.css';

function App() {
  const { initialize, isLoading } = useAuthStore();

  useEffect(() => {
    initialize();
  }, [initialize]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-500">Cargando IT Aduax...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Protected routes with Layout */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Layout><Dashboard /></Layout>
          </ProtectedRoute>
        } />

        <Route path="/estimations" element={
          <ProtectedRoute>
            <Layout><Estimations /></Layout>
          </ProtectedRoute>
        } />

        <Route path="/estimations/new" element={
          <ProtectedRoute>
            <Layout><NewEstimation /></Layout>
          </ProtectedRoute>
        } />

        <Route path="/estimations/:id" element={
          <ProtectedRoute>
            <Layout><EstimationDetail /></Layout>
          </ProtectedRoute>
        } />

        {/* Admin routes */}
        <Route path="/admin/users" element={
          <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER']}>
            <Layout><UsersAdmin /></Layout>
          </ProtectedRoute>
        } />

        <Route path="/admin/catalog" element={
          <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER']}>
            <Layout><CatalogAdmin /></Layout>
          </ProtectedRoute>
        } />

        <Route path="/admin/ba-questions" element={
          <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER']}>
            <Layout><BAQuestionsAdmin /></Layout>
          </ProtectedRoute>
        } />

        <Route path="/settings" element={
          <ProtectedRoute>
            <Layout><Settings /></Layout>
          </ProtectedRoute>
        } />

        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
